import React from 'react'
import { Accordion } from 'react-bootstrap'
import Style from './CourseTitle.module.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowDown, faClock, faStickyNote, faVideo,  } from '@fortawesome/free-solid-svg-icons'
import ReactPlayer from 'react-player'
import { convetor } from '../../Utils/MsTohr/convetor'

const CourseTitle = ({items,index}) => {
    
    return (
        <Accordion  className={Style.AcaredonHolder}>
            <Accordion.Item  eventKey='0' className='w-100'>
                <Accordion.Header  className={Style.AccordionHeader}><h4 className={Style.TitleHolder}><div><p>{index}</p>{items.name}</div> <p className={Style.arrowHolder}><FontAwesomeIcon icon={faArrowDown}/></p></h4></Accordion.Header>
                <Accordion.Body>
                <ul className={Style.AccardionBody}>
                    {
                        items.contents.map((item,index)=>{
                            return(
                                <li key={index}>
                                    <p>{item.type==='vid'?<FontAwesomeIcon icon={faVideo} color='#0465CC'/>:<FontAwesomeIcon icon={faStickyNote} color='#0465CC'/>} {item.name}</p>
                                    <p style={{color:'green'}}><FontAwesomeIcon icon={faClock} color='#CC06BB'/> {convetor(item.duration)}</p>
                                </li>
                            )
                        })
                    }
                </ul>
                </Accordion.Body>
            </Accordion.Item>
        </Accordion>
    )
}

export default CourseTitle
